import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SessionContext } from 'src/app/core/services/config/app.settings';
import { Organisme } from 'src/app/data/intervenant/models/organisme.model';
import { OrganismesService } from 'src/app/data/intervenant/services/organismes/organismes.service';
import { UtilisateurTypeCode } from 'src/app/data/intervenant/models/enums/type-utilisateur.enum';
import { BaseComponent } from 'src/app/core/components/base.component';
import { LoaderService } from '../../../../../../../core/services/loader/loader.service';

@Component({
    selector: 'app-liste-organismes',
    templateUrl: './liste-organismes.component.html',
    styleUrls: ['./liste-organismes.component.scss'],
    standalone: false
})
export class ListeOrganismesComponent extends BaseComponent implements OnInit {
    organismes: Organisme[];
    searchStringInput: string;
    searchString = '';
    searchStringUpdate = new Subject<string>();
    order = {
        property: 'id',
        reverse: false
    };

    constructor(private readonly organismesService: OrganismesService, private readonly loaderService: LoaderService) {
        super();
    }

    ngOnInit() {
        this.organismesService
            .getOrganismes()
            .pipe(this.loaderService.operator())
            .subscribe(organismes => {
                this.organismes = organismes;
            });

        this.searchStringUpdate.pipe(debounceTime(200), distinctUntilChanged()).subscribe(value => {
            this.searchString = value;
        });
    }

    setOrder(property: string) {
        if (property) {
            if (property === this.order.property) {
                this.order.reverse = !this.order.reverse;
            } else {
                this.order = {
                    property,
                    reverse: false
                };
            }
        }
    }

    getIcon(property: string) {
        if (property === this.order.property) {
            return this.order.reverse ? 'sort-down' : 'sort-up';
        } else {
            return 'sort';
        }
    }

    canModify(organisme: Organisme) {
        return organisme.id === SessionContext.get('idOrganisme') || SessionContext.get('utilisateurType') === UtilisateurTypeCode.ADMIN;
    }
}
